
























import { computed, defineComponent, ref } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import AudioPlayer from "@/components/AudioPlayer";
import BaseIcon from "@/components/BaseIcon";
import { ProcessedContentFiles } from "@/components/ContentFeedItem";

export default defineComponent({
  name: "ContentFeedAudioList",
  components: { AudioPlayer, BaseIcon },
  props: {
    fileList: { type: Object as () => ProcessedContentFiles, required: true },
  },
  setup(props) {
    const showAllFiles = ref(false);
    const filesToPrint = computed<(ContentFile & { src: string })[]>(() => {
      const files = showAllFiles.value ? props.fileList.accessed : props.fileList.accessed.slice(0, 3);
      return files.map(f => ({
        ...f,
        src: MediaFilesController.getFileUrl(f.urlPart),
      }));
    });

    return {
      showAllFiles,
      filesToPrint,
    };
  },
});
